import { useState } from 'react'
import { openGooglePopup } from '../lib/api'
import { useSession } from '../lib/session'
import { Icon } from './Icon'

/**
 * The front door. Nothing else in Bloom renders until someone is through it,
 * so this screen also has to explain any misconfiguration — otherwise a broken
 * setup just looks like a button that does nothing.
 */
export function SignIn() {
  const { me, refresh, offline } = useSession()
  const [waiting, setWaiting] = useState(false)
  const domain = me?.domain

  const signIn = () => {
    setWaiting(true)
    openGooglePopup('/api/auth/start', 'bloom:auth-ok', () => {
      setWaiting(false)
      void refresh()
    })
  }

  return (
    <div className="signin">
      <div className="card signin-card">
        <span className="mark big"><Icon name="flower" size={22} /></span>
        <h1>Sign in to Bloom</h1>
        <p className="sub">
          {domain
            ? <>Record your screen and face, then publish straight to the shared channel. Use your <strong>@{domain}</strong> Google account.</>
            : <>Record your screen and face, then publish straight to the shared channel.</>}
        </p>

        {offline && <div className="notice error">Can’t reach the Bloom server. {offline}</div>}

        {me?.issues?.length ? (
          <div className="notice warn" style={{ textAlign: 'left' }}>
            <strong>Bloom isn’t set up yet.</strong>
            <ul style={{ margin: '8px 0 0', paddingLeft: 18 }}>
              {me.issues.map((i) => <li key={i}>{i}</li>)}
            </ul>
          </div>
        ) : null}

        <button
          className="btn primary big google"
          onClick={signIn}
          disabled={waiting || !!me?.issues?.length}
        >
          <GoogleMark /> {waiting ? 'Waiting for Google…' : 'Continue with Google'}
        </button>

        <p className="small muted" style={{ margin: 0 }}>
          Bloom only asks for your name and email address. You’ll stay signed in on this
          device{domain ? '' : ''} until you sign out.
        </p>
      </div>
    </div>
  )
}

/** Google's mark, inlined — an external image would be one more thing to fail. */
function GoogleMark() {
  return (
    <svg width="17" height="17" viewBox="0 0 48 48" aria-hidden="true" className="ico">
      <path fill="#4285F4" d="M45.1 24.5c0-1.6-.1-2.8-.4-4H24v7.3h12.1c-.2 2-1.6 5-4.5 7l-.1.3 6.5 5 .5.1c4.1-3.8 6.6-9.4 6.6-15.7" />
      <path fill="#34A853" d="M24 46c5.9 0 10.9-2 14.5-5.3l-6.9-5.4c-1.8 1.3-4.3 2.2-7.6 2.2-5.8 0-10.7-3.8-12.5-9.1l-.3
        .1-6.7 5.2-.1.3C8 40.3 15.4 46 24 46" />
      <path fill="#FBBC05" d="M11.5 28.4c-.5-1.4-.7-2.9-.7-4.4s.3-3.1.7-4.4v-.3l-6.8-5.3-.2.1C2.9 17 2 20.4 2 24s.9 7 2.5 9.9z" />
      <path fill="#EA4335" d="M24 10.2c4.1 0 6.9 1.8 8.5 3.3l6.2-6C34.9 4 29.9 2 24 2 15.4 2 8 7.7 4.5 14.1l7 5.5c1.8-5.3 6.7-9.4 12.5-9.4" />
    </svg>
  )
}
